export default {
    MENU_ITEM_TITLE_HEIGHT: 70,
    MENU_ITEM_LINK_HEIGHT: 56,
    LINK_HEIGHT: 70
};
